import { render, staticRenderFns } from "./StepPrev.vue?vue&type=template&id=58b30e52&"
import script from "./StepPrev.vue?vue&type=script&lang=js&"
export * from "./StepPrev.vue?vue&type=script&lang=js&"
import style0 from "./StepPrev.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports